/**
 * Auto-selects the first available variant for the preselected color
 * when the page loads and the current variant is unavailable
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for the page to fully load
  setTimeout(function() {
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    // Get the product data
    const productScript = variantPicker.querySelector('script[type="application/json"]');
    if (!productScript) return;

    let currentVariant;
    try {
      currentVariant = JSON.parse(productScript.textContent);
    } catch (e) {
      console.error('Error parsing variant data:', e);
      return;
    }

    // If current variant is available, no need to change
    if (currentVariant && currentVariant.available) return;

    // Find all fieldsets
    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length === 0) return;

    // Find color fieldset
    let colorFieldset = /** @type {HTMLFieldSetElement|null} */ (null);
    let colorIndex = -1;

    fieldsets.forEach((fieldset, index) => {
      const legend = fieldset.querySelector('legend');
      if (legend) {
        const optionName = legend.textContent.toLowerCase().trim();
        if (optionName.includes('color') || optionName.includes('colore') || 
            optionName.includes('colour') || optionName.includes('couleur') || 
            optionName.includes('farbe')) {
          colorFieldset = /** @type {HTMLFieldSetElement} */ (fieldset);
          colorIndex = index;
        }
      }
    });

    if (!colorFieldset) return;

    // Get currently selected color
    const selectedColorInput = /** @type {HTMLInputElement} */ (colorFieldset.querySelector('input:checked'));
    if (!selectedColorInput) return;

    const selectedColorValue = selectedColorInput.value;
    
    // Find first available combination for this color
    // Look through all other fieldsets to find available options
    const otherFieldsets = Array.from(fieldsets).filter((_, index) => index !== colorIndex);
    
    // Try to find any available combination with the current color
    for (const otherFieldset of otherFieldsets) {
      const availableInputs = otherFieldset.querySelectorAll('input[data-option-available="true"]');
      
      for (const availableInput of availableInputs) {
        const inputElement = /** @type {HTMLInputElement} */ (availableInput);
        if (!inputElement.checked) {
          // Try selecting this option
          inputElement.checked = true;
          
          // Trigger change event
          const changeEvent = new Event('change', { bubbles: true });
          inputElement.dispatchEvent(changeEvent);
          
          // Break after first successful selection
          return;
        }
      }
    }
  }, 100);
});